import { SessionState } from '@piwikpro/auth-crate/reducers/session';
import { Service, inject } from '@piwikpro/platform';
import type { Store } from 'redux';

@Service()
export class MarketingService {
  private organization: string;

  private session: SessionState;

  constructor(
    @inject('store') private readonly store: Store,
  ) {
    this.organization = this.store.getState().licenseKeeper.license?.organization || 'Unknown';
    this.session = {
      ...this.store.getState().session,
      language: this.store.getState().session.language.split('-')[0],
    };
  }

  private getPiwikProductContactPageURL() {
    switch (this.session.language) {
      default:
      case 'en':
        return 'https://piwik.pro/product-contact/';
      case 'de':
        return 'https://piwikpro.de/product-contact/';
      case 'fi':
        return 'https://piwik.pro/fi-product-contact/';
      case 'fr':
        return 'https://piwikpro.fr/product-contact/';
      case 'nl':
        return 'https://piwikpro.nl/product-contact/';
      case 'sv':
        return 'https://piwikpro.se/product-contact/';
    }
  }

  private getPiwikProductPricingPageURL() {
    switch (this.session.language) {
      case 'de':
        return 'https://piwikpro.de/preise/';
      case 'fr':
        return 'https://piwikpro.fr/pricing/';
      case 'nl':
        return 'https://piwikpro.nl/piwik-pro-pakketten/';
      case 'sv':
        // there is no dedicated pricing page for now
        return 'https://piwikpro.se/';
      case 'en':
      case 'fi':
      default:
        return 'https://piwik.pro/pricing/';
    }
  }

  public getPiwikProductPricingTablePageURL() {
    switch (this.session.language) {
      case 'de':
        return 'https://piwikpro.de/preise/#uberblick';
      case 'fr':
        return 'https://piwikpro.fr/pricing/#comparaison-des-plans';
      case 'nl':
        return 'https://piwikpro.nl/piwik-pro-pakketten/#vergelijking-van-abonnementen';
      case 'sv':
      case 'en':
      case 'fi':
      case 'it':
      case 'da':
      default:
        return 'https://piwik.pro/pricing/#table';
    }
  }

  public openProductContactPage(
    { topic }: { topic: string } = { topic: '' },
  ): void {
    window.open(
      `${this.getPiwikProductContactPageURL()}?account=${this.organization}&user=${this.session.email}&topic=${encodeURIComponent(topic)}`,
      '_blank',
    );
  }

  public openProductPricingPage(): void {
    window.open(
      this.getPiwikProductPricingPageURL(),
      '_blank',
    );
  }

  public openProductPricingTablePage(): void {
    window.open(
      this.getPiwikProductPricingTablePageURL(),
      '_blank',
    );
  }
}
